// extracted by css-extract-rspack-plugin
export default {"grayBody":"Comment-grayBody_0eh","reply":"Comment-reply_kA-"};